import { Col, Row, Container } from "react-bootstrap";
import "../styles/App.scss";
import { AnimatePresence, motion } from "framer-motion";
import recommendPageData from "../data/recommendPageData";
import resultArrayToMbti from "../utils/resultArrayToMbti";

function RecommendPage({ testResults, setCurrentPage, currentPage }) {
    const resultMbti = resultArrayToMbti(testResults);
    const data = recommendPageData[resultMbti];
    return (

            <AnimatePresence mode="sync">
                <motion.div
                    className="background-image"
                    key="background"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.4 }}
                    style={{
                        backgroundImage: `url(${data.backgroundImage})`,
                    }}
                >
                    <Container>
                        <Row className="justify-content-md-center">
                            <Col>
                                <motion.div
                                    className="recommend-title"
                                    key="recommend-title"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.4 }}
                                    style={{ backgroundColor: data.bgColor }}
                                >
                                    {data.name}專屬保險推薦卡
                                </motion.div>
                            </Col>
                        </Row>
                        <Row className="justify-content-md-center">
                            <Col>
                                <AnimatePresence mode="sync">
                                    <motion.img
                                        key={resultMbti + "-image"}
                                        src={`/images/recommend-icon/${data.image}`}
                                        alt="Result Image"
                                        initial={{ opacity: 1, y: -40 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -40 }}
                                        transition={{ duration: 0.8 }}
                                        width={data.imageWidth}
                                        height={data.imageHeight}
                                    />
                                </AnimatePresence>
                            </Col>
                        </Row>
                        <Row className="justify-content-md-center">
                            <Col>
                                <div
                                    className="recommend-description"
                                    style={{ backgroundColor: data.bgColor }}
                                >
                                    {data.description
                                        .split("\n")
                                        .map((line) => [line, <br />])}
                                </div>
                            </Col>
                        </Row>
                        <Row className="justify-content-md-center">
                            <Col>
                                <motion.button
                                    className={`next-page-button-var${data.buttonVariant}`}
                                    key="recommend-button"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{ duration: 0.4 }}
                                    onClick={() => {
                                        setCurrentPage(() => currentPage + 1);
                                    }}
                                >
                                    下一頁
                                </motion.button>
                            </Col>
                        </Row>
                    </Container>
                </motion.div>
            </AnimatePresence>
    );
}

export default RecommendPage;
